import { createAPIModule, apiRequest, baseHeaders, apiUrlBase, queryString } from '@/api/utils';

const endpoint = 'documentos';

export default {
  ...createAPIModule({
    endpoint,
    getAllParams: ({
      title, category, page, perPage,
    }) => ({
      'filter[titulo]': title,
      'filter[categoria]': category,
      page,
      per_page: perPage,
    }),
  }),

  create: (data, onProgress = () => { }) => new Promise((resolve, reject) => {
    const formData = new FormData();
    /* eslint-disable-next-line array-callback-return */
    Object.keys(data).map((key) => {
      const value = data[key];
      if (key === 'file') {
        formData.append(key, value, value.name);
      } else {
        formData.append(key, value);
      }
    });

    const xhr = new XMLHttpRequest();
    const headers = baseHeaders();

    xhr.upload.onprogress = (e) => {
      onProgress({
        loaded: e.loaded,
        total: e.total,
      });
    };

    xhr.open('POST', `${apiUrlBase}/documentos`, true);

    Object.keys(headers).forEach((key) => {
      xhr.setRequestHeader(key, headers[key]);
    });

    xhr.onload = () => {
      const parsedResponse = JSON.parse(xhr.response);

      if (xhr.status >= 200 && xhr.status < 300) {
        resolve(parsedResponse);
      } else {
        reject(parsedResponse);
      }
    };

    xhr.onerror = () => reject(xhr.response);

    xhr.send(formData);
  }),

  getAllForCharge: ({
    chargeId, title, category, page, perPage,
  }) => {
    const params = {
      'filter[titulo]': title,
      'filter[categoria]': category,
      page,
      per_page: perPage,
    };

    return apiRequest.get(`documentos/encargo/${chargeId}?${queryString.stringify(params)}`);
  },

  renameDocument: ({ documentsId, newTitle }) =>
    apiRequest.post(`${endpoint}/rename`, {
      documentsId,
      newTitle,
    }),

  checkMainCategory: ({ documentsId }) =>
    apiRequest.post(`${endpoint}/checkmaincategory`, {
      documentsId,
    }),
  changeCategoriesDocuments: ({ documentsId, categoryId }) =>
    apiRequest.post(`${endpoint}/changecategory`, {
      documentsId,
      categoryId,
    }),

  starMultipleDownloadAsZip: data =>
    apiRequest.post(`${endpoint}/descargarzip`, {
      data,

    }),
};
